import { Box, ToggleButton, ToggleButtonGroup, } from "@mui/material";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import Shbutton from "../../../../theme/buttons/Shbutton";
import SaveIcon from '@mui/icons-material/Save';
import Text from "../../../../theme/text/Text";
import Dropdown from "../../../../theme/dropout/DropOut";
import { useEffect, useState } from "react";

import ButtonGroup from "../../../../theme/buttons/ButtonGroup";
import { useDeleteShipperMutation, useEditShipperMutation } from "../../../../../newapi/shipper/shipperSlice";
import { yupRequired, yupNumberRequired, yupArrayRequired } from "../../../../../utils/validation";
import ShValidatedInput from "../../../../theme/inputs/ShValidatedInput";
import ShValidatedNumberInput from "../../../../theme/inputs/ShValidatedNumberInput";
import * as yup from "yup";

import { useTranslation } from "react-i18next";
import { showToastMessageDeleteRequest, showToastMessageRequestError, showToastMessageUpdateRequest, showToastMessage } from "../../../../../utils/toasts";
import DeleteIcon from '@mui/icons-material/Delete';
import MConfirmDelete from "../../../Modals/MConfirmDelete";
import { useGetWarehousesSelectQuery } from "../../../../../newapi/warehouse/warehouseApiSlice";
import ShValidatedInputDropdown from "../../../../theme/dropdowns/ShValidatedInputDropdown";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import SpDesktopFooter from "../../../../theme/sidepanel2/SidepanelFooter";
import cx from "classnames"
import EMGeneralExplainerBox from "../../../ModalsPopover/explainers/EMGeneralExplainerBox";
import { useGetInvoiceProductsSelectWithSearchQuery } from "../../../../../newapi/financial/invoiceProductSlice";
import { useGetExternalChannelsQuery } from "../../../../../newapi/externalchannel/externalChannelSlice";

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return props.hasModifyPermission ?
        <ButtonGroup version={2}>
            <Shbutton
                isLoading={props.isLoading}
                className={"group-btn"}
                onClick={props.deleteAction}
                color="red"
                variant="contained"
                endIcon={<DeleteIcon />}
            >
                {t('delete')}
            </Shbutton>
            <Shbutton
                sx={{
                    marginLeft: 1
                }}
                isLoading={props.isLoading}
                className={"group-btn"}
                onClick={props.action}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                variant="contained"
                endIcon={<SaveIcon />}
            >
                {t('save')}
            </Shbutton>
        </ButtonGroup>
        : <></>;
};

const DetailsPanel = (props) => {
    const  { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { data: warehouses } = useGetWarehousesSelectQuery();

    const hasModifyPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.SHIPPER_MANAGE, UserPrivileges.SETTINGS_ALL])
    );

    // Claims are mailed through a mailbox external channel (Outlook or SMTP/IMAP), so the claims section only applies when one exists
    const { data: channelData } = useGetExternalChannelsQuery({
        args: { page: 1, size: 1, body: { all_credentials: true, channel_type: ["outlook", "smtpimap"], without_relation: true } }
    });
    const hasMailboxChannel = (channelData?.data?.length ?? 0) > 0;
    
    const { data: invoiceProducts, invoiceProductsIsLoading } = useGetInvoiceProductsSelectWithSearchQuery({subType: "surcharges"});

    const [shipperInfo, setShipperInfo] = useState({
        id: 0,
        name: "",
        // reference: "",
        maxWeight: 0,
        maxLength: 0,
        maxWidth: 0,
        maxHeight: 0,
        maxVolume: 0,
        warehouses: []
    });
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setShipperInfo(props.data);
        setShipperInfo({
            ...props.data,
            warehouses: props.data?.warehouses?.map(warehouse => warehouse.id)
        });
    },[props.data]);

    const handleChange = (key, value) => {
        // Update volume
        let update = {};
        if (["maxLength", "maxWidth", "maxHeight"].includes(key)){
            const dimensions = {
                ...shipperInfo,
                [key]: value
            }

            if (dimensions.maxLength > 0 && dimensions.maxWidth > 0 && dimensions.maxHeight > 0){
                update.maxVolume = dimensions.maxLength * dimensions.maxWidth * dimensions.maxHeight;
            }
        }

        setShipperInfo(prev => ({
            ...prev,
            [key]: value,
            ...update
        }));
        
        // Optionally clear the error for that field
        setFieldErrors({
          ...fieldErrors,
          [key]: '',
          ...Object.fromEntries(Object.keys(update).map(key => [key, '']))
        });
    };

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        name: yupRequired('name',t),
        // reference: yupRequired('reference',t),
    };
    
    const schema = yup.object().shape(rules);

    const [EditShipper,{isLoading}] = useEditShipperMutation();
    const handleSaveClick = async () => {
        try {
            if (isLoading) return;
            if (!shipperInfo?.warehouses || shipperInfo?.warehouses.length === 0) {
                showToastMessage("error", `${t("warehouse")} ${t("validation_required")}`, 10000);
                return;
            }

            const updateData = {
                id: shipperInfo?.id,
                name: shipperInfo?.name,
                // reference: shipperInfo?.reference,
                maxWeight: shipperInfo?.maxWeight,
                maxLength: shipperInfo?.maxLength,
                maxWidth: shipperInfo?.maxWidth,
                maxHeight: shipperInfo?.maxHeight,
                maxVolume: shipperInfo?.maxVolume,
                warehouses: shipperInfo?.warehouses,
                manualOrderServicePoint: shipperInfo?.manualOrderServicePoint,
                customsAdvanceFee: shipperInfo?.customsAdvanceFee,
                customsFeeProductId: shipperInfo?.customsFeeProductId,
                canCreateClaim: shipperInfo?.canCreateClaim,
                claimDaysToReminder: shipperInfo?.claimDaysToReminder,
                claimEmailaddress: shipperInfo?.claimEmailaddress,
                invoiceOnlyWithShipperDimensions: shipperInfo?.invoiceOnlyWithShipperDimensions
            }
            setFieldErrors({});
            await schema.validate(updateData, { abortEarly: false });
            const data = await EditShipper({
                ...updateData
              }).unwrap()
            showToastMessageUpdateRequest(t, data);
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                    ...acc,
                    [currentError.path]: currentError.message
                }), {});
            
                // Set the validation errors in the state
                setFieldErrors(errors);
            } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("update_failed"), t, err);
            }
        }        
    };

    const [DeleteShipperMutation] = useDeleteShipperMutation();
    const confirmDelete = async () => {
        try {
            const response = await DeleteShipperMutation(props.data.id).unwrap();
            showToastMessageDeleteRequest(t, response);
            props.setIsExtended(false);
        } catch (err) {
            showToastMessageDeleteRequest(t, {success: false, error: err.error});
        }
    };
    const handleDeleteClick = async () => {
        setOpen(true);
    };

    const confirmDeleteModal = {
        data: shipperInfo?.name,
        open: open,
        setOpen: setOpen,
        confirm: confirmDelete
    }


    useEffect(() => {
        props.replaceView({
            ...props.config,
            mobileActions:<GridActions 
                id={props.data?.id}
                isLoading={isLoading}
                hasModifyPermission={hasModifyPermission}
                action={handleSaveClick}
                deleteAction={handleDeleteClick}/>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[props.data?.id,handleSaveClick,handleDeleteClick,hasModifyPermission]);

    const labelWidth = 320;

    return (
        <Box height={1} display={"flex"} flexDirection={"column"} paddingX={3}
            sx={{
                "@media screen and (min-width: 48.1em)"  :{
                    marginBottom:11
                }
            }}
        >
            <Dropdown title={t("basic")} open>
                <Box sx={{
                    display:"flex",
                    justifyContent:"space-between",
                    flexDirection:"column",
                    "@media screen and (max-width: 47.9375em)" : {
                        flexDirection:"column"
                    }
                }}>
                    
                    {/* Two columns */}
                    
                    <Box flex={4}
                        sx={{
                            display:"flex",
                            gap:4,
                            justifyContent:"flex-start"
                        }}
                    >
                        <Box
                            sx={{
                                "@media screen and (max-width: 47.9375em)" : {
                                    flex:1
                                }
                            }}
                        >
                            <Box sx={{
                            width:80,
                            flexShrink:0,
                            height:32,
                            display:"flex",
                            alignItems:"center",
                        }}>
                                <Text>{t("name")}</Text>
                            </Box>
                        </Box>
                        <Box>
                            <Box display="flex"
                                height="32px"
                                // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[100]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                                <ShValidatedInput
                                    name="name"
                                    value={shipperInfo?.name || ""}
                                    onChange={handleChange}
                                    error={fieldErrors.name}
                                />
                            </Box>
                            
                        </Box>
                    </Box>

                    {/* <Box flex={4}
                        sx={{
                            display:"flex",
                            gap:4,
                            justifyContent:"flex-start"
                        }}
                    > 
                        <Box
                            sx={{
                                "@media screen and (max-width: 47.9375em)" : {
                                    flex:1,
                                    // width:1
                                }
                            }}
                        >
                            <Box sx={{
                            width:80,
                            flexShrink:0,
                            height:32,
                            display:"flex",
                            alignItems:"center",
                        }}>
                                <Text>{t("reference")}</Text>
                            </Box>
                            
                        </Box>
                        <Box>
                            <Box display="flex"
                                height="32px"
                            // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[100]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                                <ShValidatedInput
                                    name="reference"
                                    value={shipperInfo?.reference || ""}
                                    onChange={handleChange}
                                    error={fieldErrors.reference}
                                />
                            </Box>
                            
                        </Box>
                    </Box> */}
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        // alignItems:"flex-start",
                        // justifyContent:"space-between",
                        gap: 7,
                        paddingTop:1,
                    }}
                >

                    <Box
                        sx={{
                            width:60,
                            flexShrink:0,
                            height:32,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text>{t("warehouse")}</Text>
                    </Box>
                    <InputDropdown
                        key={shipperInfo?.warehouses}
                        name="warehouses"
                        displayName="name"
                        changeField="id"
                        valueKey="id"
                        multiple
                        selected={shipperInfo?.warehouses ?? []}
                        options={warehouses?.data ?? []}
                        noSelection={t("choose_warehouses")} 
                        onChange={(val) => handleChange("warehouses",val)}
                    />
                </Box>
            </Dropdown>
            <Dropdown title={t("measurements")} subTitle={t("shipper_max_dimensions_and_weight_description")} open={window.innerWidth > 767} sx={{paddingBottom:"0px"}}>
            {/* <Divider></Divider> */}
                <Box sx={{
                    display:"flex",
                    flexDirection:"column"
                }}>
                    {/* Two columns */}
                    <Box
                        sx={{
                            display:"flex",
                            gap:4,
                            justifyContent:"flex-start"
                        }}
                    >
                        {/* <Box display={"flex"} flexDirection={"column"} gap={2}> */}
                            <Box lineHeight={"38px"}>
                                <Text>{t("max_weight")} (gram)</Text>
                                <ShValidatedNumberInput
                                    name="maxWeight"
                                    value={shipperInfo?.maxWeight ?? 0}
                                    onChange={handleChange}
                                    error={fieldErrors.maxWeight}
                                />
                            </Box>
                            <Box lineHeight={"40px"}>
                                <Text>{t("max_length")} ({t("mm")})</Text>
                                <ShValidatedNumberInput
                                    name="maxLength"
                                    value={shipperInfo?.maxLength ?? 0}
                                    onChange={handleChange}
                                    error={fieldErrors.maxLength}
                                />
                            </Box>
                            <Box lineHeight={"40px"}>
                                <Text>{t("max_width")} ({t("mm")})</Text>
                                <ShValidatedNumberInput
                                    name="maxWidth"
                                    value={shipperInfo?.maxWidth ?? 0}
                                    onChange={handleChange}
                                    error={fieldErrors.maxWidth}
                                />
                            </Box>
                            
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:4,
                            justifyContent:"flex-start"
                        }}
                    >
                    <Box lineHeight={"40px"}>
                                <Text>{t("max_height")} ({t("mm")})</Text>
                                <ShValidatedNumberInput
                                    name="maxHeight"
                                    value={shipperInfo?.maxHeight ?? 0}
                                    onChange={handleChange}
                                    error={fieldErrors.maxHeight}
                                />
                            </Box>
                            <Box lineHeight={"40px"}>
                                <Text>{t("max_volume")} ({t("mm")})</Text>
                                <ShValidatedNumberInput
                                    name="maxVolume"
                                    value={shipperInfo?.maxVolume ?? 0}
                                    onChange={handleChange}
                                    error={fieldErrors.maxVolume}
                                />
                            </Box>
                            </Box>
                    <Box>
                    </Box>
                    </Box>
            </Dropdown>
        <Dropdown title={`${t("customs")} - ${t('united_states')}`} open>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                
                {/* Two columns */}
                
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:labelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("customs_advance_fee")}</Text>
                        <EMGeneralExplainerBox
                            title={t("customs_advance_fee")}
                            text={t("customs_advance_fee_text")}
                        />
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                                <ShValidatedNumberInput
                                    name="customsAdvanceFee"
                                    value={shipperInfo?.customsAdvanceFee ?? 0}
                                    onChange={handleChange}
                                    error={fieldErrors.customsAdvanceFee}
                                />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:labelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("customs_advance_fee_product")}</Text>
                        <EMGeneralExplainerBox
                            title={t("customs_advance_fee_product")}
                            text={t("customs_advance_fee_product_text")}
                        />
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="name"
                        displayName="name"
                        selected={invoiceProducts ? invoiceProducts.findIndex(item => item.id === shipperInfo?.customsFeeProductId) ?? -1 : -1}
                        options={invoiceProducts ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('customsFeeProductId', invoiceProducts[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                </Box>
            </Box>
        </Dropdown>
            {["dhl", "postnl", "ampere", "zineps", "innosendv2"].includes(shipperInfo?.type) && (
            <Dropdown title={t("service_points")} open>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Box sx={{ width: labelWidth, display: "flex", alignItems: "center" }}>
                                <Text>{t("service_point_delivery_manual_orders")}</Text>
                        </Box>
                        <ToggleButtonGroup
                            color={shipperInfo?.manualOrderServicePoint ? "green" : "red"}
                            value={shipperInfo?.manualOrderServicePoint ?? false}
                            exclusive
                            onChange={(e) => handleChange("manualOrderServicePoint", e.target.value === "true")}
                            className={cx(`${shipperInfo?.manualOrderServicePoint}`, {
                                'active': shipperInfo?.manualOrderServicePoint
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                className={cx(``, { 'active': !shipperInfo?.manualOrderServicePoint })}
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.active, &.Mui-selected, &.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value={false}>
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                className={cx(``, { 'active': shipperInfo?.manualOrderServicePoint })}
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.active,&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value={true}
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
            </Dropdown>
            )}

            {/* <Box
                sx={{
                    position:"absolute",
                    bottom:0,
                    right:0,
                    padding:3,
                    width:1,
                    background:theme.palette.mode === "dark" ? colors.bg["tertiary"] : colors.grey[0],
                    "@media screen and (min-width: 47.9376em) and (max-width: 63.9375em)" : {
                        padding:2,
                        paddingY:2.5,
                    }
                }}
            >
                   
            </Box> */}
            {["dhl", "myparcel", "myparcelcom", "gls", "postnl"].includes(shipperInfo?.type) && (
            <Dropdown title={t("financial")} open>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Box sx={{ width: labelWidth, display: "flex", alignItems: "center" }}>
                            <Text noBreak>{t("invoice_only_with_shipper_dimensions")}</Text>
                            <EMGeneralExplainerBox
                                title={t("invoice_only_with_shipper_dimensions")}
                                text={t("invoice_only_with_shipper_dimensions_text")}
                            />
                        </Box>
                        <ToggleButtonGroup
                            color={shipperInfo?.invoiceOnlyWithShipperDimensions ? "green" : "red"}
                            value={shipperInfo?.invoiceOnlyWithShipperDimensions ?? false}
                            exclusive
                            onChange={(e) => handleChange("invoiceOnlyWithShipperDimensions", e.target.value === "true")}
                            className={cx(`${shipperInfo?.invoiceOnlyWithShipperDimensions}`, {
                                'active': shipperInfo?.invoiceOnlyWithShipperDimensions
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                className={cx(``, { 'active': !shipperInfo?.invoiceOnlyWithShipperDimensions })}
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.active, &.Mui-selected, &.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value={false}>
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                className={cx(``, { 'active': shipperInfo?.invoiceOnlyWithShipperDimensions })}
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.active,&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value={true}
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
            </Dropdown>
            )}

            {hasMailboxChannel && ["dhl", "postnl"].includes(shipperInfo?.type) && (
            <Dropdown title={t("claims")} open isLast>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Box sx={{ width: labelWidth, display: "flex", alignItems: "center" }}>
                            <Text noBreak>{t("can_create_claim")}</Text>
                        </Box>
                        <ToggleButtonGroup
                            color={shipperInfo?.canCreateClaim ? "green" : "red"}
                            value={shipperInfo?.canCreateClaim ?? false}
                            exclusive
                            onChange={(e) => handleChange("canCreateClaim", e.target.value === "true")}
                            className={cx(`${shipperInfo?.canCreateClaim}`, {
                                'active': shipperInfo?.canCreateClaim
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                className={cx(``, { 'active': !shipperInfo?.canCreateClaim })}
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.active, &.Mui-selected, &.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value={false}>
                                {t('inactive')}
                            </ToggleButton>
                            <ToggleButton
                                className={cx(``, { 'active': shipperInfo?.canCreateClaim })}
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.active,&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value={true}
                            >
                                {t('active')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Box sx={{ width: labelWidth, display: "flex", alignItems: "center" }}>
                            <Text noBreak>{t("claim_emailaddress")}</Text>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <ShValidatedInput
                                name="claimEmailaddress"
                                value={shipperInfo?.claimEmailaddress || ""}
                                onChange={handleChange}
                                error={fieldErrors.claimEmailaddress}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Box sx={{ width: labelWidth, display: "flex", alignItems: "center" }}>
                            <Text noBreak>{t("claim_days_to_reminder")}</Text>
                            <EMGeneralExplainerBox
                                title={t("claim_days_to_reminder")}
                                text={t("claim_days_to_reminder_text")}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <ShValidatedNumberInput
                                name="claimDaysToReminder"
                                value={shipperInfo?.claimDaysToReminder ?? 0}
                                onChange={handleChange}
                                error={fieldErrors.claimDaysToReminder}
                            />
                        </Box>
                    </Box>
                </Box>
            </Dropdown>
            )}

            <SpDesktopFooter>
                <GridActions
                    id={props.data?.id}
                    isLoading={isLoading}
                    hasModifyPermission={hasModifyPermission}
                    action={handleSaveClick}
                    deleteAction={handleDeleteClick}
                    // active={active}
                    // blocked={blocked}
                    // remark={remark}
                    // carrier={carrier}
                    // quarantine={quarantine}
                    // enableLinkingWhenBlocked={enableLinkingWhenBlocked}
                />

            </SpDesktopFooter>
            
             <MConfirmDelete
                open={confirmDeleteModal.open}
                handleClose={() => confirmDeleteModal.setOpen(false)}
                data={confirmDeleteModal.data}
                confirm={confirmDeleteModal.confirm}
            />
        </Box>
    );
}

export default DetailsPanel;